module.exports = __webpack_public_path__ + "img/7.01fef85e.png";